// Copyright 2021 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { SettingsModal } from "modules/modals/SettingsModal";
import { NearFieldModule } from "modules/workflows/Streamer/NearField/NearFieldModule";

@autoinject
export class StreamerNearFieldSettingsModal extends SettingsModal<NearFieldModule> {}
